import {Pipe, PipeTransform} from '@angular/core';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {FormattedNumberPipe} from '@shared/pipes/number.pipe';

@Pipe({
	name: 'multiCurrency'
})

export class MultiCurrencyPipe implements PipeTransform {
	private readonly _localeId: string;
	private readonly currency: string;

	constructor(
		private appConfig: AppConfigEnvironmentService
	) {
		switch (this.appConfig.Environment.SERVER_DATE_LOCATION) {
			case 'it' :
				this.currency = '€';
				this._localeId = 'it-IT';
				break;
			case 'en':
				this.currency = '£';
				this._localeId = 'en-GB';
				break;
			case 'us' :
				this.currency = '$';
				this._localeId = 'en-US';
				break;
			default :
				this.currency = '€';
				this._localeId = 'it-IT';
				break;
		}
	}

	transform(value: number, position: CurrencyPosition = CurrencyPosition.SUFFIX, digitsInfo: string = '2.2-2', locale: string = this._localeId): string {
		if (value !== null) {
			const formattedNumberPipe: FormattedNumberPipe = new FormattedNumberPipe(this.appConfig);
			switch (position) {
				case CurrencyPosition.PREFIX:
					return `${this.currency} ${formattedNumberPipe.transform(value, digitsInfo, locale)}`;
				case CurrencyPosition.SUFFIX:
					return `${formattedNumberPipe.transform(value, digitsInfo, locale)} ${this.currency} `;
				case CurrencyPosition.ONLY_CURRENCY:
					return this.currency;
			}
		} else {
			return '';
		}
	}
}


export enum CurrencyPosition {
	PREFIX,
	SUFFIX,
	ONLY_CURRENCY
}